import {useSelector} from "react-redux";
import {css, cx} from "@panda/css";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import type {IRPStore} from "../../../app/rp_reducer";
import {CreditEstimatedValue} from "../../../credit_calculator/components/CreditEstimatedValue";
import {replaceDigitsWithZeros} from "../../../credit_calculator/utils/replace_digits_with_zeros";
import {getCurrency} from "../../../utils/get_currency";
import type {IOfferDetail} from "../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    variant: "visible" | "blur";
}

export const OfferDetailHeaderHiddenPriceVariantPrice = (props: IProps) => {
    const {offer, variant} = props;

    const lowestPriceProperty = useSelector((state: IRPStore) => state.offerDetail.lowestPriceProperty);

    const price = lowestPriceProperty?.price ?? null;
    const priceM2 = lowestPriceProperty?.price_m2 ?? null;

    const hasPrice = typeof price === "number" && price > 0;
    const hasPriceM2 = typeof priceM2 === "number" && priceM2 > 0;

    if (!hasPrice) {
        return null;
    }

    const currency = getCurrency({currency: offer.currency});
    const isBlurred = variant === "blur";

    const getDisplayPrice = (value: number): string => {
        const formatted = numberFormat(value);
        return isBlurred ? replaceDigitsWithZeros(formatted ?? "") : formatted || "";
    };

    return (
        <div className={cx(priceWrapper, isBlurred && blurStyle)} aria-hidden={isBlurred}>
            <div className={priceContainerStyle}>
                <Text as="div" variant="headline_1" className={priceStyle}>
                    <Highlight>
                        <Text as="span" variant="headline_6">
                            od{" "}
                        </Text>
                        {getDisplayPrice(price)}{" "}
                        <Text as="span" variant="headline_6">
                            {currency}
                        </Text>
                    </Highlight>
                </Text>

                {hasPriceM2 && (
                    <Text as="div" variant="body_copy_2" strong className={priceM2Style}>
                        {getDisplayPrice(priceM2)}{" "}
                        <Text as="span" variant="info_txt_2" strong>
                            {currency}/m2
                        </Text>
                    </Text>
                )}
            </div>
            <CreditEstimatedValue price={price} currency={offer.currency} className={creditRow} shouldBlur={isBlurred} />
        </div>
    );
};

const priceWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const priceStyle = css({
    lineHeight: "1"
});

const priceContainerStyle = css({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    gap: 1
});

const priceM2Style = css({
    lineHeight: "1",
    pb: 0.5
});

const creditRow = css({
    mt: 0.5
});

const blurStyle = css({
    filter: "blur(8px)",
    userSelect: "none",
    pointerEvents: "none"
});
import {useSelector} from "react-redux";
import {css, cx} from "@panda/css";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import type {IRPStore} from "../../../app/rp_reducer";
import {CreditEstimatedValue} from "../../../credit_calculator/components/CreditEstimatedValue";
import {replaceDigitsWithZeros} from "../../../credit_calculator/utils/replace_digits_with_zeros";
import {getCurrency} from "../../../utils/get_currency";
import type {IOfferDetail} from "../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    variant: "visible" | "blur";
}

export const OfferDetailHeaderHiddenPriceVariantPrice = (props: IProps) => {
    const {offer, variant} = props;

    const lowestPriceProperty = useSelector((state: IRPStore) => state.offerDetail.lowestPriceProperty);

    const price = lowestPriceProperty?.price ?? null;
    const priceM2 = lowestPriceProperty?.price_m2 ?? null;

    const hasPrice = typeof price === "number" && price > 0;
    const hasPriceM2 = typeof priceM2 === "number" && priceM2 > 0;

    if (!hasPrice) {
        return null;
    }

    const currency = getCurrency({currency: offer.currency});
    const isBlurred = variant === "blur";

    const getDisplayPrice = (value: number): string => {
        const formatted = numberFormat(value);
        return isBlurred ? replaceDigitsWithZeros(formatted ?? "") : formatted || "";
    };

    return (
        <div className={cx(priceWrapper, isBlurred && blurStyle)} aria-hidden={isBlurred}>
            <div className={priceContainerStyle}>
                <Text as="div" variant="headline_1" className={priceStyle}>
                    <Highlight>
                        <Text as="span" variant="headline_6">
                            od{" "}
                        </Text>
                        {getDisplayPrice(price)}{" "}
                        <Text as="span" variant="headline_6">
                            {currency}
                        </Text>
                    </Highlight>
                </Text>

                {hasPriceM2 && (
                    <Text as="div" variant="body_copy_2" strong className={priceM2Style}>
                        {getDisplayPrice(priceM2)}{" "}
                        <Text as="span" variant="info_txt_2" strong>
                            {currency}/m2
                        </Text>
                    </Text>
                )}
            </div>
            <CreditEstimatedValue price={price} currency={offer.currency} className={creditRow} shouldBlur={isBlurred} />
        </div>
    );
};

const priceWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const priceStyle = css({
    lineHeight: "1"
});

const priceContainerStyle = css({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    gap: 1
});

const priceM2Style = css({
    lineHeight: "1",
    pb: 0.5
});

const creditRow = css({
    mt: 0.5
});

const blurStyle = css({
    filter: "blur(8px)",
    userSelect: "none",
    pointerEvents: "none"
});
